<script>
  import { Select } from 'bits-ui'
  import { X } from 'lucide-svelte'
  
  let { value = $bindable(), items, type = "single", load, contentProps, placeholder = "Rechercher...", ...restProps } = $props()

  let filteredItems = $derived(items.filter((item) => !value.includes(item.value)))
  
  let triggerClass = "input text-left data-placeholder:text-gray-400 data-placeholder:text-xs data-placeholder:pl-3 data-multiselect:px-2"
  let listClass = "bg-white shadow-xl border border-gray-100 max-h-[300px] overflow-y-auto py-2 rounded-md w-[var(--bits-select-anchor-width)] min-w-[var(--bits-select-anchor-width)] z-50"
  let itemClass = "px-4 py-2 text-[13px] text-gray-800 border-b border-gray-100 last:border-b-0 hover:bg-blue-50 data-selected:bg-blue-50"
  
  function removeItem(item) {
    value = value.filter((v) => v !== item)
  }

  function handleKeyDown(event) {
    if (!event.key === "Backspace") return handleDelete()
    console.log("Keydown", event)
  }

  function handleDelete() {
    if (type === "single") value = ""
    if (type === "multiple") value = value.filter((v) => v !== value[value.length - 1])
  }
  
</script>

<Select.Root bind:value {type} {items} {...restProps}>
  
  <Select.Trigger data-multiselect={type === "multiple"} class={triggerClass} onkeydown={handleKeyDown}>
    {#if type === "single"}
      {#if value}
        <span>{items.find((item) => item.value === value)?.label}</span>
      {:else}
        <span>{placeholder}</span>
      {/if}
    {:else if type === "multiple"}
      {#if value.length > 0}
      <div class="flex flex-wrap gap-2">
        {#each value as item (item)}
          {@const label = items.find((i) => i.value === item)?.label}
          <div class="bg-blue-50 border border-blue-100 rounded-sm px-2 py-1 text-xs flex items-center gap-2">
            <span>{label}</span>
            <button type="button" class="hover:text-blue-500 cursor-pointer" onclick={() => removeItem(item)}>
              <X size={12} />
            </button>
          </div>
        {/each}
      </div>
      {:else}
        <span>{placeholder}</span>
      {/if}
    {/if}
  </Select.Trigger>

  <Select.Portal>
    <Select.Content class={listClass} sideOffset={10}>
      <Select.ScrollUpButton class="flex w-full items-center justify-center">
        Up
      </Select.ScrollUpButton>
      <Select.Viewport class="p-1">
        {#each filteredItems as item, i (i + item.value)}
          <Select.Item class={itemClass} value={item.value} label={item.label} disabled={item.disabled}>
            {#snippet children({ selected })}
              {item.label}
            {/snippet}
          </Select.Item>
        {/each}
      </Select.Viewport>
      <Select.ScrollDownButton class="flex w-full items-center justify-center">
        Down
      </Select.ScrollDownButton>
    </Select.Content>
  </Select.Portal>
</Select.Root>